// components/ProgressoAnalise.tsx
import React from 'react';
import {
  Grid,
  Alert,
  LinearProgress,
  Typography,
  Box,
  Stack
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';

interface ProgressoAnaliseProps {
  progresso: number;
  statusImportacao: string;
}

const ProgressoAnalise: React.FC<ProgressoAnaliseProps> = ({ progresso, statusImportacao }) => {
  const isConcluido = progresso === 100;

  // if(progresso === 0) {
  //     return <></>;
  // }

  return (
    <Box mt={4} p={2}>
      <Stack spacing={2}>
        <Alert
          icon={isConcluido ? <CheckCircleIcon fontSize="inherit" /> : <HourglassTopIcon fontSize="inherit" />}
          severity={isConcluido ? 'success' : 'info'}
        >
          <Typography variant="body1" fontWeight={500}>
            {isConcluido
              ? 'A Análise de divergências foi concluída com sucesso. Veja abaixo os resultados encontrados.'
              : statusImportacao}
          </Typography>
        </Alert>

        <Box>
          <Typography variant="body2" gutterBottom>
            Progresso da análise: <strong>{progresso}%</strong>
          </Typography>

          <LinearProgress
            variant="determinate"
            value={progresso}
            sx={{
              height: 12,
              borderRadius: 2,
              backgroundColor: isConcluido ? '#e0f2f1' : '#f0f0f0',
              '& .MuiLinearProgress-bar': {
                backgroundColor: isConcluido ? '#2e7d32' : '#1976d2',
              },
              animation: progresso < 100 ? 'pulse 1s ease-in-out infinite' : undefined,
              '@keyframes pulse': {
                '0%': { opacity: 1 },
                '50%': { opacity: 0.5 },
                '100%': { opacity: 1 },
              },
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default ProgressoAnalise;
